<template>
  <dialog-full-screen :dialog="studentEvaluationDialog" titleName="Avaliação do Aluno" @close="closeDialog()">
    <v-container>

      <student-header-info />
      <v-row>

        <student-info :readonly="mesocycleIsFinished" />
        <heart-info :readonly="mesocycleIsFinished" />
        <biochemical-info :isStudent="userIsStudent" :readonly="mesocycleIsFinished || userIsStudent" />

      </v-row>
      <v-row>
        <v-col cols="12">
          <v-tabs class="student-evaluation-tabs">
            <template v-for="(tab, index) in evaluatedTabs">
              <v-tab :key="`tab-${index}`">
                {{ allTabs[tab].title }}
              </v-tab>
              <v-tab-item :key="`tab-item-${index}`" eager>
                <component :is="allTabs[tab].component" :readonly="mesocycleIsFinished" :isStudent="userIsStudent"
                  v-if="studentEvaluationDialog" @closeDialog="closeDialog()"
                  @updateMesocycleEvaluation="updateWithParam" />
              </v-tab-item>
            </template>
            <v-spacer />
            <v-btn color="primary" class="mt-2" @click="checkEvaluationPdfDownload">
              Gerar PDF da avaliação
            </v-btn>

            <v-menu offset-y v-if="isUserAdmin">
              <template v-slot:activator="{ on }">
                <v-btn @click.stop="" v-on="on" color="primary" class="mt-2 ml-2">
                  Gerar Treino
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="generateTraining">
                  <v-list-item-title>
                    Meu EstagIArio
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="goToTraining">
                  <v-list-item-title>
                    Treino Manual
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn v-else color="primary" class="mt-2 ml-2" @click="goToTraining">
              Ir para treino
            </v-btn>
          </v-tabs>
        </v-col>
      </v-row>

    </v-container>

    <confirm-dialog title="Alteração não salva"
      message="Para baixar a avaliação é necessário que esteja salva. Deseja continuar?" cancelButton="Cancelar"
      confirmButton="Continuar" :confirmationDialog="updateEvaluationDialog" @confirm="downloadEvaluationPdf()"
      @cancel="() => updateEvaluationDialog = false" />
  </dialog-full-screen>
</template>

<script>
import DialogFullScreen from '@/components/base/DialogFullScreen'
import StudentHeaderInfo from '@/components/student/show/studentEvaluation/StudentHeaderInfo'
import StudentInfo from '@/components/student/show/studentEvaluation/StudentInfo'
import HeartInfo from '@/components/student/show/studentEvaluation/HeartInfo'
import BiochemicalInfo from '@/components/student/show/studentEvaluation/BiochemicalInfo'
import Perimetria from '@/components/student/show/studentEvaluation/Perimetria'
import Somatotipo from '@/components/student/show/studentEvaluation/Somatotipo'
import Postura from '@/components/student/show/studentEvaluation/Postura'
import GastoCalorico from '@/components/student/show/studentEvaluation/GastoCalorico'
import TesteForca from '@/components/student/show/studentEvaluation/TesteForca'
import ConfirmDialog from '@/components/base/ConfirmDialog'
import mesocycleService from '@/services/mesocycle-service'
import DocumentService from '@/services/document-service.js'
import { mapGetters, mapActions } from 'vuex'
import { cloneDeep, isEqual } from 'lodash'

export default {
  name: 'student-meso-cycle-detail',
  components: {
    DialogFullScreen,
    Perimetria,
    Somatotipo,
    StudentInfo,
    StudentHeaderInfo,
    HeartInfo,
    BiochemicalInfo,
    GastoCalorico,
    Postura,
    ConfirmDialog,
    TesteForca
  },
  data: () => ({
    allTabs: {
      caloric_expenditure: {
        title: 'Gasto Calórico',
        component: GastoCalorico
      },
      perimeter: {
        title: 'Perimetria',
        component: Perimetria
      },

      posture: {
        title: 'Postura',
        component: Postura
      },
      strength: {
        title: 'Teste de Força',
        component: TesteForca
      }
    },
    updateEvaluationDialog: false,
    evaluationCopy: {}
  }),
  mounted () {
    this.copyEvaluation()
  },
  methods: {
    ...mapActions('base', ['setSnackbar', 'fetchPdf']),
    ...mapActions('students', ['setStudentEvaluationDialog', 'setMesocycles', 'setMesocycleToBeEvaluated', 'setMesocycleEvaluation', 'setMesocycleTraining', 'setStudentEvaluationDialog', 'setTrainingDialog']),
    closeDialog () {
      this.$emit('updateList')
      this.setStudentEvaluationDialog(false)
    },
    copyEvaluation () {
      this.evaluationCopy = cloneDeep(this.mesocycleToBeEvaluated.evaluated_items)
    },
    updateWithParam ($event) {
      this.update($event)
    },
    update (close = '') {
      this.updateEvaluation()
        .then((data) => {
          this.setSnackbar({
            color: 'success',
            show: true,
            message: 'Avaliação salva com sucesso'
          })
          this.copyEvaluation()
          if (close === 'close') {
            this.closeDialog()
          }
          // this.$emit('updateList')
        })
        .catch(() => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: 'Erro ao salvar avaliação'
          })
        })
    },
    updateEvaluation () {
      const payload = { ...this.mesocycleToBeEvaluated, evaluation: true }
      return mesocycleService.mesocycleSaveEvaluation(this.student.id, payload.macrocycle.id, payload)
    },
    valuesToCompare (object) {
      const {
        // eslint-disable-next-line camelcase
        caloric_expenditure: { aerobic_items, travel_distance, water },
        perimeter: { bodyPerimeter, protocolo, skinFold },
        somatotype: { femur, umero },
        biochemical,
        posture,
        heart,
        student
      } = object

      return {
        biochemical,
        aerobic_items,
        travel_distance,
        water,
        heart,
        bodyPerimeter,
        protocolo,
        skinFold,
        posture,
        femur,
        umero,
        student
      }
    },
    checkEvaluationPdfDownload () {
      if (!isEqual(this.valuesToCompare(this.evaluationCopy), this.valuesToCompare(this.mesocycleToBeEvaluated.evaluated_items))) {
        this.updateEvaluationDialog = true
      } else {
        this.downloadEvaluationPdf()
      }
    },
    goToTraining () {
      const mesocycle = this.mesocycleToBeEvaluated

      if (!mesocycle.weeks || mesocycle.weeks === 0) {
        this.getTrainings()
      } else {
        this.$router.push({
          name: 'StudentShowMesociclo',
          params: { id: this.student.id, idMacrociclo: mesocycle.macrocycle.id, idMesociclo: mesocycle.id }
        })
      }
    },
    generateTraining () {
      const posture = this.mesocycleToBeEvaluated.evaluated_items?.posture_evaluated
      if (!posture) {
        this.getTrainings()
      } else {
        this.getTrainings(posture)
      }
    },
    async downloadEvaluationPdf () {
      this.updateEvaluation()
        .then(() => {
          this.updateEvaluationDialog = false
          this.copyEvaluation()

          const payload = {
            studentId: this.mesocycleToBeEvaluated.macrocycle.student_id,
            macrocycleId: this.mesocycleToBeEvaluated.macrocycle.id,
            mesocycleId: this.mesocycleToBeEvaluated.id
          }

          const mesocycleName = this.mesocycleToBeEvaluated && this.mesocycleToBeEvaluated.name ? this.mesocycleToBeEvaluated.name : 'sem nome'
          const tag = Object.values(payload).join('.')
          const fileName = `${tag} - ${mesocycleName}.pdf`

          this.fetchPdf({ service: DocumentService.getEvaluationPdf, payload, fileName })
        })
        .catch(() => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: 'Não foi possível gerar o PDF'
          })
        })
    },
    getTrainings (iaPosture = null) {
      mesocycleService
        .getMesocycleTraining(this.student.id, this.mesocycleToBeEvaluated.macrocycle.id, this.mesocycleToBeEvaluated.id, iaPosture)
        .then(({ data }) => {
          this.setStudentEvaluationDialog(false)
          this.setMesocycleToBeEvaluated(this.mesocycleToBeEvaluated)
          this.setMesocycleTraining(data)
          this.setTrainingDialog(true)
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response.data.errors.detail
          })
        })
    }
  },
  computed: {
    ...mapGetters('students', ['student', 'students', 'studentEvaluationDialog', 'mesocycleToBeEvaluated']),
    ...mapGetters('auth', ['user']),
    userIsStudent () {
      return this.user.isStudent()
    },
    mesocycleIsFinished () {
      const now = new Date()
      const endDate = new Date(`${this.mesocycleToBeEvaluated.end_date} 23:59:59`)

      return endDate < now
    },
    evaluatedTabs () {
      try {
        let f = this.mesocycleToBeEvaluated.macrocycle.items_to_be_evaluated

        f.sort()

        return [
          'posture',
          'caloric_expenditure',
          'perimeter',
          'strength'
        ]
        // return [...this.mesocycleToBeEvaluated.macrocycle.items_to_be_evaluated, 'strength']
      } catch (error) {
        return []
      }
    },
    isUserAdmin () {
      return [91, 8].includes(this.user.id) && this.mesocycleToBeEvaluated.trainings?.length === 0
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1264px) {
  .container {
    max-width: 1264px;
  }
}

.student-evaluation-tabs {
  &>.v-tabs-bar {
    border-bottom: solid 1px lightgrey !important;
  }
}
</style>
